<template>
  <div class="">
    <table class="table table-striped" :class="isDarkMode ? 'table-dark' : ''">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col" v-for="provider in Object.keys(provider)" :key="provider">
            {{ provider }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currency in Object.keys(currencies)" :key="currency">
          <th scope="row">{{ currency }}</th>
          <td
            scope="col"
            v-for="provider in Object.keys(provider)"
            :key="generateProviderCurrencyId(provider, currency)"
          >
            <input
              class="form-check-input"
              type="checkbox"
              :value="generateProviderCurrencyId(provider, currency)"
              :id="generateProviderCurrencyId(provider, currency)"
              :checked="isSelected(provider, currency)"
              @change="toggleProvider(provider, currency, $event.target.checked)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { PROVIDER_FIAT, PROVIDER_CRYPTO, BC_CODES } from '@shared/config/exchangesConstants'
import { useConfig } from '@shared/stores/config.js'
import { generateProviderCurrencyId } from '@shared/utils/exchangesHelper'
import { computed } from 'vue'

export default {
  name: 'ProvidersTable',

  components: {},

  props: {
    provider: {
      type: Object,
      required: true
    },
    currencies: {
      type: Object,
      required: true
    },
    selectedProvider: {
      type: Object,
      required: true
    }
  },

  setup(props, { emit }) {
    const config = useConfig()
    const isDarkMode = computed(() => config.theme === 'dark')
    const isSelected = (provider, currency) => {
      switch (provider) {
        case PROVIDER_FIAT.CR:
          return props.selectedProvider?.[provider]?.includes(currency)
        case PROVIDER_FIAT.BC:
          return props.selectedProvider?.[provider]?.includes(BC_CODES[currency])
        case PROVIDER_FIAT.AV:
        case PROVIDER_FIAT.FK:
        case PROVIDER_CRYPTO.BB:
          return props.selectedProvider?.[provider]?.some((item) => item.name === currency)
        default:
          return false
      }
    }
    const toggleProvider = (provider, currency, isSelected) => {
      emit('providerSelected', { provider, currency, isSelected })
    }
    return { generateProviderCurrencyId, toggleProvider, isSelected, isDarkMode }
  }
}
</script>

<style>
.form-check-input:checked:focus,
.form-check-input:checked:active {
  background-image: var(--bs-form-check-bg-image) !important;
}
</style>
